export default __webpack_public_path__ + "static/media/link-expired.0a99dc6d.svg";